module.exports = __webpack_public_path__ + "static/media/BwModelica-Light.2cc6e63b.otf";